import { legacyNormalizeExpression } from "../utils/legacyNormalizeExpression.js";
/**
 * Parse "if" parameter
 * Translates the condition if provided.
 * @private
 * @return {string} "if_" + ifValue
 */
export function process_if(ifValue) {
    return ifValue ? "if_" + legacyNormalizeExpression(ifValue) : ifValue;
}
